"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelsWithBrand = exports.translateModelToSlug = exports.translateModel = exports.findModelByName = exports.findModel = exports.MODELS_ARRAY = void 0;
const Brand_1 = require("../brand/Brand");
exports.MODELS_ARRAY = {
    "alfa-romeo": [
        ["Giulia", "giulia"],
        ["Giulietta", "giulietta"],
        ["Stelvio", "stelvio"],
        ["Mito", "mito"],
    ],
    "audi": [
        ["A1", "a1"],
        ["A2", "a2"],
        ["A3", "a3"],
        ["A4", "a4"],
        ["A4 Allroad", "a4-allroad"],
        ["A5", "a5"],
        ["A6", "a6"],
        ["A6 Allroad", "a6-allroad"],
        ["A7", "a7"],
        ["A8", "a8"],
        ["Q2", "q2"],
        ["Q3", "q3"],
        ["Q4", "q4"],
        ["Q5", "q5"],
        ["Q7", "q7"],
        ["Q8", "q8"],
        ["S1", "s1"],
        ["S2", "s2"],
        ["S3", "s3"],
        ["S4", "s4"],
        ["S5", "s5"],
        ["S6", "s6"],
        ["S7", "s7"],
        ["S8", "s8"],
        ["SQ2", "sq2"],
        ["SQ5", "sq5"],
        ["SQ7", "sq7"],
        ["SQ8", "sq8"],
        ["RS2", "rs2"],
        ["RS3", "rs3"],
        ["RS4", "rs4"],
        ["RS5", "rs5"],
        ["RS6", "rs6"],
        ["RS7", "rs7"],
        ["RS Q3", "rs-q3"],
        ["RS Q8", "rs-q8"],
        ["TT", "tt"],
        ["TT RS", "tt-rs"],
        ["TT S", "tt-s"],
        ["e-tron", "e-tron"],
        ["e-tron GT", "e-tron-gt"],
    ],
    "bmw": [
        ["Seria 1", "seria-1"],
        ["Seria 2", "seria-2"],
        ["Seria 3", "seria-3"],
        ["Seria 4", "seria-4"],
        ["Seria 5", "seria-5"],
        ["Seria 6", "seria-6"],
        ["Seria 7", "seria-7"],
        ["Seria 8", "seria-8"],
        ["X1", "x1"],
        ["X2", "x2"],
        ["X3", "x3"],
        ["X3 M", "x3-m"],
        ["X4", "x4"],
        ["X4 M", "x4-m"],
        ["X5", "x5"],
        ["X5 M", "x5-m"],
        ["X6", "x6"],
        ["X6 M", "x6-m"],
        ["X7", "x7"],
        ["Z4", "z4"],
        ["Z4 M", "z4-m"],
        ["i3", "i3"],
        ["i8", "i8"],
        ["iX3", "ix3"],
        ["iX", "ix"],
        ["i4", "i4"],
        ["M2", "m2"],
        ["M3", "m3"],
        ["M4", "m4"],
        ["M5", "m5"],
        ["M6", "m6"],
        ["M8", "m8"],
    ],
    "citroen": [
        ["2 CV", "2-cv"],
        ["AX", "ax"],
        ["Axel", "axel"],
        ["Berlingo", "berlingo"],
        ["BX", "bx"],
        ["C1", "c1"],
        ["C2", "c2"],
        ["C3", "c3"],
        ["C3 Aircross", "c3-aircross"],
        ["C3 Picasso", "c3-picasso"],
        ["C3 Pluriel", "c3-pluriel"],
        ["C4", "c4"],
        ["C4 Aircross", "c4-aircross"],
        ["C4 Cactus", "c4-cactus"],
        ["C4 Grand Picasso", "c4-grand-picasso"],
        ["C4 Picasso", "c4-picasso"],
        ["C4 SpaceTourer", "c4-spacetourer"],
        ["C5", "c5"],
        ["C5 Aircross", "c5-aircross"],
        ["C5X", "c5x"],
        ["C6", "c6"],
        ["C8", "c8"],
        ["CX", "cx"],
        ["C-Zero", "c-zero"],
        ["DS", "ds"],
        ["DS3", "ds3"],
        ["DS4", "ds4"],
        ["DS5", "ds5"],
        ["Evasion", "evasion"],
        ["GSA", "gsa"],
        ["Jumper", "jumper"],
        ["Jumpy Combi", "jumpy-combi"],
        ["Nemo", "nemo"],
        ["SM", "sm"],
        ["Saxo", "saxo"],
        ["SpaceTourer", "spacetourer"],
        ["Visa", "visa"],
        ["XM", "xm"],
        ["Xantia", "xantia"],
        ["Xsara", "xsara"],
        ["Xsara Picasso", "xsara-picasso"],
        ["ZX", "zx"]
    ],
    "dacia": [
        ["Dokker", "dokker"],
        ["Dokker Van", "dokker-van"],
        ["Duster", "duster"],
        ["Jogger", "jogger"],
        ["Lodgy", "lodgy"],
        ["Logan", "logan"],
        ["Logan Van", "logan-van"],
        ["Sandero", "sandero"],
        ["Sandero Stepway", "sandero-stepway"],
        ["Spring", "spring"],
    ],
    "fiat": [
        ["500", "500"],
        ["500L", "500l"],
        ["500X", "500x"],
        ["Bravo", "bravo"],
        ["Doblo", "doblo"],
        ["Ducato", "ducato"],
        ["Fiorino", "fiorino"],
        ["Grande Punto", "grande-punto"],
        ["Punto", "punto"],
        ["Panda", "panda"],
        ["Scudo", "scudo"],
        ["Talento", "talento"],
        ["Tipo", "tipo"],
    ],
    "kia": [
        ["Ceed", "ceed"],
        ["Optima", "optima"],
        ["Picanto", "picanto"],
        ["Pro ceed", "pro-ceed"],
        ["Retona", "retona"],
        ["Rio", "rio"],
        ["Sorento", "sorento"],
        ["Soul", "soul"],
        ["Sportage", "sportage"],
        ["Niro", "niro"],
        ["Stinger", "stinger"],
        ["Stonic", "stonic"],
        ["XCeed", "xceed"],
        ["EV6", "ev6"],
    ],
    "cupra": [
        ["Ateca", "ateca"],
        ["Leon", "cupra-leon"],
        ["Leon Sportstourer", "cupra-leon-st"],
        ["Formentor", "cupra-formentor"],
    ],
    "porsche": [
        ["356", "356"],
        ["911", "911"],
        ["912", "912"],
        ["914", "914"],
        ["924", "924"],
        ["928", "928"],
        ["944", "944"],
        ["959", "959"],
        ["962", "962"],
        ["968", "968"],
        ["Boxster", "boxster"],
        ["Carrera GT", "carrera-gt"],
        ["Cayenne", "cayenne"],
        ["Cayman", "cayman"],
        ["Macan", "macan"],
        ["Panamera", "panamera"],
        ["718 Boxster", "718-boxster"],
        ["718 Cayman", "718-cayman"],
        ["Taycan", "taycan"],
        ["718 Spyder", "718-spyder"],
    ],
    "hyundai": [
        ["Accent", "accent"],
        ["Atos", "atos"],
        ["Avante", "avante"],
        ["Azera", "azera"],
        ["Coupe", "coupe"],
        ["Elantra", "elantra"],
        ["Equus", "equus"],
        ["Excel", "excel"],
        ["Galloper", "galloper"],
        ["Genesis", "genesis"],
        ["Genesis Coupe", "genesis-coupe"],
        ["Getz", "getz"],
        ["Grand Santa Fe", "grand-santa-fe"],
        ["Grandeur", "grandeur"],
        ["H-1", "h-1"],
        ["H-1 Starex", "h-1-starex"],
        ["H200", "h200"],
        ["Lantra", "lantra"],
        ["Matrix", "matrix"],
        ["Pony", "pony"],
        ["S-Coupe", "s-coupe"],
        ["Santa Fe", "santa-fe"],
        ["Santamo", "santamo"],
        ["Sonata", "sonata"],
        ["Sonica", "sonica"],
        ["Terracan", "terracan"],
        ["Trajet", "trajet"],
        ["Tucson", "tucson"],
        ["Veloster", "veloster"],
        ["Veracruz", "veracruz"],
        ["XG 30", "xg-30"],
        ["XG 350", "xg-350"],
        ["i10", "i10"],
        ["i20", "i20"],
        ["i25", "i25"],
        ["i30", "i30"],
        ["i40", "i40"],
        ["ix20", "ix20"],
        ["ix35", "ix35"],
        ["ix55", "ix55"],
        ["IONIQ", "ioniq"],
        ["H350", "h350"],
        ["Kona", "kona"],
        ["i30 N", "i30-n"],
        ["Bayon", "bayon"],
    ],
    "mercedes-benz": [
        ["W201 (190)", "w201-190"],
        ["280", "280"],
        ["Klasa A", "klasa-a"],
        ["Klasa B", "klasa-b"],
        ["Klasa C", "klasa-c"],
        ["CL", "cl"],
        ["CLC", "clc"],
        ["CLK", "clk"],
        ["CLS", "cls"],
        ["Citan", "citan"],
        ["CLA", "cla"],
        ["Klasa E", "klasa-e"],
        ["Klasa G", "klasa-g"],
        ["GL", "gl"],
        ["GLA", "gla"],
        ["GLK", "glk"],
        ["ML", "ml"],
        ["MB 100", "mb-100"],
        ["Monarch", "monarch"],
        ["Klasa R", "klasa-r"],
        ["Klasa S", "klasa-s"],
        ["SL", "sl"],
        ["SLK", "slk"],
        ["SLR", "slr"],
        ["Sprinter", "sprinter"],
        ["Klasa V", "klasa-v"],
        ["Vaneo", "vaneo"],
        ["Vario", "vario"],
        ["Viano", "viano"],
        ["Vito", "vito"],
        ["W123", "w123"],
        ["W124 (1984-1993)", "w124-1984-1993"],
        ["AMG GT", "amg-gt"],
        ["GLC", "glc"],
        ["GLE", "gle"],
        ["GLS", "gls"],
        ["SLC", "slc"],
        ["Klasa X", "x-klasa"],
        ["SLS", "sls"],
        ["EQC", "eqc"],
        ["GLB", "glb"],
        ["EQV", "eqv"],
        ["EQA", "eqa"],
        ["EQS", "eqs"],
        ["EQB", "eqb"],
        ["EQE", "eqe"],
        ["Klasa T", "t-klasa"],
    ],
    "ford": [
        ["Aerostar", "aerostar"],
        ["Aspire", "aspire"],
        ["B-MAX", "b-max"],
        ["Bronco", "bronco"],
        ["C-MAX", "c-max"],
        ["Capri", "capri"],
        ["Contour", "contour"],
        ["Cougar", "cougar"],
        ["Courier", "courier"],
        ["Crown", "crown"],
        ["EDGE", "edge"],
        ["Econoline", "econoline"],
        ["Econovan", "econovan"],
        ["Escape", "escape"],
        ["Escort", "escort"],
        ["Excursion", "excursion"],
        ["Expedition", "expedition"],
        ["Explorer", "explorer"],
        ["F150", "f150"],
        ["F250", "f250"],
        ["F350", "f350"],
        ["FIVE HUNDRED", "five-hundred"],
        ["Fairlane", "fairlane"],
        ["Falcon", "falcon"],
        ["Festiva", "festiva"],
        ["Fiesta", "fiesta"],
        ["Focus", "focus"],
        ["Focus C-Max", "focus-c-max"],
        ["Freestar", "freestar"],
        ["Freestyle", "freestyle"],
        ["Fusion", "fusion"],
        ["GT", "gt"],
        ["Galaxy", "galaxy"],
        ["Granada", "granada"],
        ["KA", "ka"],
        ["Kuga", "kuga"],
        ["Maverick", "maverick"],
        ["Mercury", "mercury"],
        ["Mondeo", "mondeo"],
        ["Mustang", "mustang"],
        ["Orion", "orion"],
        ["Probe", "probe"],
        ["Puma", "puma"],
        ["Ranchero", "ranchero"],
        ["Ranger", "ranger"],
        ["S-Max", "s-max"],
        ["Scorpio", "scorpio"],
        ["Sierra", "sierra"],
        ["Streetka", "streetka"],
        ["Taunus", "taunus"],
        ["Taurus", "taurus"],
        ["Tempo", "tempo"],
        ["Thunderbird", "thunderbird"],
        ["Tourneo Connect", "tourneo-connect"],
        ["Tourneo Courier", "tourneo-courier"],
        ["Tourneo Custom", "tourneo-custom"],
        ["Transit", "transit"],
        ["Transit Connect", "transit-connect"],
        ["Transit Courier", "transit-courier"],
        ["Transit Custom", "transit-custom"],
        ["Windstar", "windstar"],
        ["EcoSport", "ecosport"],
        ["Grand C-MAX", "grand-c-max"],
        ["Ka+", "ka_plus"],
        ["Ranger Raptor", "ranger-raptor"],
        ["Mustang Mach-E", "mustang-mach-e"],
        ["Flex", "flex"],
    ],
    "mazda": [
        ["121", "121"],
        ["2", "2"],
        ["3", "3"],
        ["323", "323"],
        ["323F", "323f"],
        ["5", "5"],
        ["6", "6"],
        ["626", "626"],
        ["929", "929"],
        ["BT-50", "bt-50"],
        ["Bongo", "bongo"],
        ["CX-5", "cx-5"],
        ["CX-7", "cx-7"],
        ["CX-9", "cx-9"],
        ["Demio", "demio"],
        ["MPV", "mpv"],
        ["MX-3", "mx-3"],
        ["MX-5", "mx-5"],
        ["MX-6", "mx-6"],
        ["Millenia", "millenia"],
        ["Premacy", "premacy"],
        ["Protege", "protege"],
        ["RX-6", "rx-6"],
        ["RX-7", "rx-7"],
        ["RX-8", "rx-8"],
        ["Seria B", "seria-b"],
        ["Seria E", "seria-e"],
        ["Tribute", "tribute"],
        ["Xedos", "xedos"],
        ["CX-3", "cx-3"],
        ["CX-30", "cx-30"],
        ["MX-30", "mx-30"],
        ["CX-60", "cx-60"],
    ],
    "seat": [
        ["Alhambra", "alhambra"],
        ["Altea", "altea"],
        ["Altea XL", "altea-xl"],
        ["Arosa", "arosa"],
        ["Cordoba", "cordoba"],
        ["Exeo", "exeo"],
        ["Ibiza", "ibiza"],
        ["Inca", "inca"],
        ["Leon", "leon"],
        ["Malaga", "malaga"],
        ["Marbella", "marbella"],
        ["Mii", "mii"],
        ["Ronda", "ronda"],
        ["Terra", "terra"],
        ["Toledo", "toledo"],
        ["Ateca", "ateca"],
        ["Arona", "arona"],
        ["Tarraco", "tarraco"],
    ],
    "skoda": [
        ["100", "100"],
        ["105", "105"],
        ["120", "120"],
        ["130", "130"],
        ["135", "135"],
        ["Citigo", "citigo"],
        ["Fabia", "fabia"],
        ["Favorit", "favorit"],
        ["Felicia", "felicia"],
        ["Forman", "forman"],
        ["Octavia", "octavia"],
        ["Praktik", "praktik"],
        ["RAPID", "rapid"],
        ["Roomster", "roomster"],
        ["Superb", "superb"],
        ["Yeti", "yeti"],
        ["Kodiaq", "kodiaq"],
        ["Karoq", "karoq"],
        ["Scala", "scala"],
        ["Kamiq", "kamiq"],
        ["Enyaq", "enyaq"],
    ],
    "peugeot": [
        ["1007", "1007"],
        ["104", "104"],
        ["106", "106"],
        ["107", "107"],
        ["108", "108"],
        ["2008", "2008"],
        ["204", "204"],
        ["205", "205"],
        ["206", "206"],
        ["206 CC", "206-cc"],
        ["206 plus", "206-plus"],
        ["207", "207"],
        ["207 CC", "207-cc"],
        ["208", "208"],
        ["3008", "3008"],
        ["301", "301"],
        ["304", "304"],
        ["305", "305"],
        ["306", "306"],
        ["307", "307"],
        ["307 CC", "307-cc"],
        ["308", "308"],
        ["308 CC", "308-cc"],
        ["309", "309"],
        ["395", "395"],
        ["4007", "4007"],
        ["4008", "4008"],
        ["404", "404"],
        ["405", "405"],
        ["406", "406"],
        ["407", "407"],
        ["408", "408"],
        ["5008", "5008"],
        ["504", "504"],
        ["505", "505"],
        ["508", "508"],
        ["604", "604"],
        ["605", "605"],
        ["607", "607"],
        ["806", "806"],
        ["807", "807"],
        ["Bipper", "bipper"],
        ["Expert", "expert"],
        ["Partner", "partner"],
        ["RCZ", "rcz"],
        ["Boxer", "boxer"],
        ["Traveller", "traveller"],
        ["Rifter", "rifter"],
        ["iOn", "ion"],
    ],
    "toyota": [
        ["4-Runner", "4-runner"],
        ["Auris", "auris"],
        ["Avalon", "avalon"],
        ["Avensis", "avensis"],
        ["Avensis Verso", "avensis-verso"],
        ["Aygo", "aygo"],
        ["Camry", "camry"],
        ["Camry Solara", "camry-solara"],
        ["Carina", "carina"],
        ["Celica", "celica"],
        ["Corolla", "corolla"],
        ["Corolla Verso", "corolla-verso"],
        ["Corolla Cross", "corolla-cross"],
        ["Cressida", "cressida"],
        ["Crown", "crown"],
        ["Dyna", "dyna"],
        ["FJ", "fj"],
        ["GT86", "gt86"],
        ["Hiace", "hiace"],
        ["Highlander", "highlander"],
        ["Hilux", "hilux"],
        ["Land Cruiser", "land-cruiser"],
        ["Lite-Ace", "lite-ace"],
        ["MR2", "mr2"],
        ["Matrix", "matrix"],
        ["Paseo", "paseo"],
        ["Picnic", "picnic"],
        ["Previa", "previa"],
        ["Prius", "prius"],
        ["RAV4", "rav4"],
        ["Sequoia", "sequoia"],
        ["Sienna", "sienna"],
        ["Starlet", "starlet"],
        ["Supra", "supra"],
        ["Tacoma", "tacoma"],
        ["Tercel", "tercel"],
        ["Tundra", "tundra"],
        ["Urban Cruiser", "urban-cruiser"],
        ["Venza", "venza"],
        ["Verso", "verso"],
        ["Verso S", "verso-s"],
        ["Yaris", "yaris"],
        ["Yaris Verso", "yaris-verso"],
        ["iQ", "iq"],
        ["C-HR", "c-hr"],
        ["ProAce", "proace"],
        ["Mirai", "mirai"],
        ["Proace Verso", "proace-verso"],
        ["Proace City Verso", "proace-city-verso"],
        ["Prius+", "prius_plus"],
        ["Proace City", "proace-city"],
        ["Yaris Cross", "yaris-cross"],
        ["bZ4X", "bz4x"],
    ],
    "land-rover": [
        ["Defender", "defender"],
        ["Discovery", "discovery"],
        ["Discovery Sport", "discovery-sport"],
        ["Freelander", "freelander"],
        ["Range Rover", "range-rover"],
        ["Range Rover Evoque", "range-rover-evoque"],
        ["Range Rover Sport", "range-rover-sport"],
        ["Range Rover Velar", "range-rover-velar"],
    ],
    "nissan": [
        ["100 NX", "100-nx"],
        ["200 SX", "200-sx"],
        ["240 SX", "240-sx"],
        ["280 ZX", "280-zx"],
        ["300 ZX", "300-zx"],
        ["350 Z", "350-z"],
        ["370 Z", "370-z"],
        ["Almera", "almera"],
        ["Almera Tino", "almera-tino"],
        ["Altima", "altima"],
        ["Armada", "armada"],
        ["Bluebird", "bluebird"],
        ["Cherry", "cherry"],
        ["Cube", "cube"],
        ["Frontier", "frontier"],
        ["GT-R", "gt-r"],
        ["Interstar", "interstar"],
        ["Juke", "juke"],
        ["King Cab", "king-cab"],
        ["Kubistar", "kubistar"],
        ["Laurel", "laurel"],
        ["Maxima", "maxima"],
        ["Micra", "micra"],
        ["Murano", "murano"],
        ["NP300 Pickup", "np300-pickup"],
        ["NV200", "nv200"],
        ["Navara", "navara"],
        ["Note", "note"],
        ["Pathfinder", "pathfinder"],
        ["Patrol", "patrol"],
        ["Pickup", "pickup"],
        ["Pixo", "pixo"],
        ["Prairie", "prairie"],
        ["Primastar", "primastar"],
        ["Primera", "primera"],
        ["Pulsar", "pulsar"],
        ["Qashqai", "qashqai"],
        ["Qashqai+2", "qashqai-2"],
        ["Quest", "quest"],
        ["Rogue", "rogue"],
        ["Sentra", "sentra"],
        ["Serena", "serena"],
        ["Silvia", "silvia"],
        ["Skyline", "skyline"],
        ["Stanza", "stanza"],
        ["Sunny", "sunny"],
        ["Terrano", "terrano"],
        ["Tiida", "tiida"],
        ["Titan", "titan"],
        ["Trade", "trade"],
        ["Urvan", "urvan"],
        ["Vanette", "vanette"],
        ["X-Trail", "x-trail"],
        ["Xterra", "xterra"],
        ["Leaf", "leaf"],
        ["NV300", "nv300"],
        ["NV400", "nv400"],
        ["Townstar", "townstar"],
        ["Ariya", "ariya"],
    ],
    "lexus": [
        ["CT", "ct"],
        ["ES", "es"],
        ["GS", "gs"],
        ["GX", "gx"],
        ["HS 250h", "hs-250h"],
        ["IS", "is"],
        ["LFA", "lfa"],
        ["LS", "ls"],
        ["LX", "lx"],
        ["NX", "nx"],
        ["RX", "rx"],
        ["SC", "sc"],
        ["RC", "rc"],
        ["LC", "lc"],
        ["UX", "ux"],
    ],
    "volkswagen": [
        ["181", "181"],
        ["Amarok", "amarok"],
        ["Beetle", "beetle"],
        ["Bora", "bora"],
        ["Buggy", "buggy"],
        ["CC", "cc"],
        ["Caddy", "caddy"],
        ["California", "california"],
        ["Caravelle", "caravelle"],
        ["Corrado", "corrado"],
        ["Crafter", "crafter"],
        ["Eos", "eos"],
        ["Fox", "fox"],
        ["Garbus", "garbus"],
        ["Golf", "golf"],
        ["Golf Plus", "golf-plus"],
        ["Golf Sportsvan", "golf-sportsvan"],
        ["Iltis", "iltis"],
        ["Jetta", "jetta"],
        ["Kafer", "kafer"],
        ["Karmann Ghia", "karmann-ghia"],
        ["Lupo", "lupo"],
        ["Multivan", "multivan"],
        ["New Beetle", "new-beetle"],
        ["Passat", "passat"],
        ["Passat CC", "passat-cc"],
        ["Phaeton", "phaeton"],
        ["Polo", "polo"],
        ["Santana", "santana"],
        ["Scirocco", "scirocco"],
        ["Sharan", "sharan"],
        ["Tiguan", "tiguan"],
        ["Touareg", "touareg"],
        ["Touran", "touran"],
        ["Transporter", "transporter"],
        ["Vento", "vento"],
        ["up!", "up"],
        ["Arteon", "arteon"],
        ["T-Roc", "t-roc"],
        ["Tiguan Allspace", "tiguan-allspace"],
        ["Routan", "routan"],
        ["T-Cross", "t-cross"],
        ["Teramont", "teramont"],
        ["ID.3", "id3"],
        ["Atlas", "atlas"],
        ["LT", "lt"],
        ["ID.4", "id4"],
        ["Taigo", "taigo"],
        ["ID.5", "id5"],
        ["ID.Buzz", "id-buzz"],
    ],
    "opel": [
        ["Adam", "adam"],
        ["Agila", "agila"],
        ["Ampera", "ampera"],
        ["Antara", "antara"],
        ["Arena", "arena"],
        ["Ascona", "ascona"],
        ["Astra", "astra"],
        ["Calibra", "calibra"],
        ["Campo", "campo"],
        ["Cascada", "cascada"],
        ["Combo", "combo"],
        ["Commodore", "commodore"],
        ["Corsa", "corsa"],
        ["Diplomat", "diplomat"],
        ["Frontera", "frontera"],
        ["GT", "gt"],
        ["Insignia", "insignia"],
        ["Kadett", "kadett"],
        ["Manta", "manta"],
        ["Meriva", "meriva"],
        ["Mokka", "mokka"],
        ["Monterey", "monterey"],
        ["Monza", "monza"],
        ["Movano", "movano"],
        ["Nova", "nova"],
        ["Omega", "omega"],
        ["Pick up Sportcap", "pick-up-sportcap"],
        ["Rekord", "rekord"],
        ["Senator", "senator"],
        ["Signum", "signum"],
        ["Sintra", "sintra"],
        ["Speedster", "speedster"],
        ["Tigra", "tigra"],
        ["Vectra", "vectra"],
        ["Vivaro", "vivaro"],
        ["Zafira", "zafira"],
        ["Karl", "karl"],
        ["Crossland X", "crossland-x"],
        ["Grandland X", "grandland-x"],
        ["Grandland", "grandland"],
        ["Crossland", "crossland"],
    ],
    "volvo": [
        ["Seria 200", "seria-200"],
        ["245", "245"],
        ["262", "262"],
        ["340", "340"],
        ["Seria 300", "seria-300"],
        ["Seria 400", "seria-400"],
        ["Seria 700", "seria-700"],
        ["744", "744"],
        ["745", "745"],
        ["780", "780"],
        ["850", "850"],
        ["855", "855"],
        ["Seria 900", "seria-900"],
        ["945", "945"],
        ["965", "965"],
        ["C30", "c30"],
        ["C70", "c70"],
        ["Polar", "polar"],
        ["S40", "s40"],
        ["S60", "s60"],
        ["S70", "s70"],
        ["S80", "s80"],
        ["S90", "s90"],
        ["V40", "v40"],
        ["V50", "v50"],
        ["V60", "v60"],
        ["V70", "v70"],
        ["V90", "v90"],
        ["XC 60", "xc-60"],
        ["XC 70", "xc-70"],
        ["XC 90", "xc-90"],
        ["XC 40", "xc-40"],
        ["C40", "c-40"],
        ["MY23", "my23"],
        ["V90 Cross Country", "v90-cross-country"],
    ],
    "jaguar": [
        ["Daimler", "daimler"],
        ["E-Type", "e-type"],
        ["F-Type", "f-type"],
        ["MK II", "mk-ii"],
        ["S-Type", "s-type"],
        ["X-Type", "x-type"],
        ["XF", "xf"],
        ["XJ", "xj"],
        ["XK", "xk"],
        ["XK8", "xk8"],
        ["XE", "xe"],
        ["F-Pace", "f-pace"],
        ["E-Pace", "e-pace"],
        ["I-Pace", "i-pace"],
        ["XJS", "xjs"],
        ["XJR", "xjr"],
    ],
    "suzuki": [
        ["Alto", "alto"],
        ["Across", "across"],
        ["Baleno", "baleno"],
        ["Cappucino", "cappucino"],
        ["Carry", "carry"],
        ["Celerio", "celerio"],
        ["Grand Vitara", "grand-vitara"],
        ["Ignis", "ignis"],
        ["Jimny", "jimny"],
        ["Kizashi", "kizashi"],
        ["LJ", "lj"],
        ["Liana", "liana"],
        ["Reno", "reno"],
        ["Swace", "swace"],
        ["SJ", "sj"],
        ["SX4", "sx4"],
        ["SX4 S-Cross", "sx4-s-cross"],
        ["Samurai", "samurai"],
        ["Splash", "splash"],
        ["Super-Carry", "super-carry"],
        ["Swift", "swift"],
        ["Vitara", "vitara"],
        ["Wagon R+", "wagon-r"],
        ["X-90", "x-90"],
        ["XL7", "xl7"],
        ["XL7", "xl7"],
    ],
    "renault": [
        ["Avantime", "avantime"],
        ["Captur", "captur"],
        ["Clio", "clio"],
        ["Coupe", "coupe"],
        ["Espace", "espace"],
        ["Express", "express"],
        ["Fluence", "fluence"],
        ["Fuego", "fuego"],
        ["Grand Espace", "grand-espace"],
        ["Grand Scenic", "grand-scenic"],
        ["Kangoo", "kangoo"],
        ["Koleos", "koleos"],
        ["Laguna", "laguna"],
        ["Latitude", "latitude"],
        ["Master", "master"],
        ["Megane", "megane"],
        ["Modus", "modus"],
        ["Safrane", "safrane"],
        ["Scenic", "scenic"],
        ["Scenic Conquest", "scenic-conquest"],
        ["Scenic RX4", "scenic-rx4"],
        ["Symbol", "symbol"],
        ["Thalia", "thalia"],
        ["Trafic", "trafic"],
        ["Twingo", "twingo"],
        ["Twizy", "twizy"],
        ["Vel Satis", "vel-satis"],
        ["Wind", "wind"],
        ["Kadjar", "kadjar"],
        ["Talisman", "talisman"],
        ["Alaskan", "alaskan"],
        ["Alaskan", "alaskan"],
        ["Zoe", "zoe"],
        ["Arkana", "arkana"],
        ["Austral", "austral"],
    ],
    "honda": [
        ["Accord", "accord"],
        ["Aerodeck", "aerodeck"],
        ["CR-V", "cr-v"],
        ["CR-Z", "cr-z"],
        ["CRX", "crx"],
        ["City", "city"],
        ["Civic", "civic"],
        ["Element", "element"],
        ["FR-V", "fr-v"],
        ["HR-V", "hr-v"],
        ["Insight", "insight"],
        ["Integra", "integra"],
        ["Jazz", "jazz"],
        ["Legend", "legend"],
        ["Logo", "logo"],
        ["NSX", "nsx"],
        ["Odyssey", "odyssey"],
        ["Pilot", "pilot"],
        ["Prelude", "prelude"],
        ["Ridgeline", "ridgeline"],
        ["S 2000", "s-2000"],
        ["Shuttle", "shuttle"],
        ["Stream", "stream"],
        ["e", "e"],
        ["e:NSP1", "e-nsp1"],
        ["e:NP1", "e-np1"],
        ["e:NY1", "e-ny1"],
        ["ZR-V", "zr-v"],
    ],
    "mini": [
        ["1000", "1000"],
        ["1300", "1300"],
        ["Clubman", "clubman"],
        ["Cooper", "cooper"],
        ["Cooper S", "cooper-s"],
        ["Countryman", "countryman"],
        ["ONE", "one"],
        ["Paceman", "paceman"],
        ["John Cooper Works", "john-cooper-works"],
    ],
    "jeep": [
        ["CJ", "cj"],
        ["Cherokee", "cherokee"],
        ["Comanche", "comanche"],
        ["Commander", "commander"],
        ["Compass", "compass"],
        ["Grand Cherokee", "grand-cherokee"],
        ["Liberty", "liberty"],
        ["Patriot", "patriot"],
        ["Renegade", "renegade"],
        ["Wagoneer", "wagoneer"],
        ["Willys", "willys"],
        ["Wrangler", "wrangler"],
        ["Gladiator", "j-gladiator"],
        ["Avenger", "avenger"],
    ],
    "smart": [
        ["Crossblade", "crossblade"],
        ["Forfour", "forfour"],
        ["Fortwo", "fortwo"],
        ["Roadster", "roadster"],
        ["Roomster", "roomster"],
    ],
    "lamborghini": [
        ["Aventador", "aventador"],
        ["Countach", "countach"],
        ["Diablo", "diablo"],
        ["Espada", "espada"],
        ["Gallardo", "gallardo"],
        ["Huracan", "huracan"],
        ["Jalpa", "jalpa"],
        ["LM", "lm"],
        ["Miura", "miura"],
        ["Murcielago", "murcielago"],
        ["Urraco", "urraco"],
        ["Urus", "urus"],
    ],
    "maserati": [
        ["224", "224"],
        ["3200", "3200"],
        ["Biturbo", "biturbo"],
        ["Coupe", "coupe"],
        ["Ghibli", "ghibli"],
        ["GranCabrio", "grancabrio"],
        ["GranTurismo", "granturismo"],
        ["Gransport", "gransport"],
        ["Merak", "merak"],
        ["Quattroporte", "quattroporte"],
        ["Spyder", "spyder"],
        ["Levante", "levante"],
        ["Grecale", "grecale"],
        ["MC20", "mc20"],
        ["MC20 Cielo", "mc20-cielo"],
        ["Shamal", "shamal"],
    ],
    "isuzu": [
        ["Campo", "campo"],
        ["D-Max", "d-max"],
        ["Gemini", "gemini"],
        ["Midi", "midi"],
        ["Pick up", "pick-up"],
        ["trooper", "trooper"],
    ],
    "abarth": [
        ["124", "124"],
        ["595", "595"],
        ["695", "695"],
        ["Grande Punto", "grande-punto"],
        ["500", "500"],
        ["Punto Evo", "punto-evo"],
    ],
    "aixam": [
        ["A721", "a721"],
        ["A741", "a741"],
        ["A751", "a751"],
        ["City", "city"],
        ["Coupe", "coupe"],
        ["Crossline", "crossline"],
        ["Crossover", "crossover"],
        ["GTO", "gto"],
        ["Roadline", "roadline"],
        ["Scouty", "scouty"],
        ["Scouty R", "scouty-r"],
    ],
    "alpine": [
        ["A110", "a110"],
    ],
    "aston-martin": [
        ["Bulldog", "bulldog"],
        ["Cygnet", "cygnet"],
        ["DB", "db"],
        ["DB Mk III", "db-mk-iii"],
        ["DB1", "db1"],
        ["DB2", "db2"],
        ["DB4", "db4"],
        ["DB5", "db5"],
        ["DB6", "db6"],
        ["DB7", "db7"],
        ["DB9", "db9"],
        ["DBS", "dbs"],
        ["Lagonda", "lagonda"],
        ["One-77", "one-77"],
        ["Rapide", "rapide"],
        ["V12 Vanquish", "v12-vanquish"],
        ["V12 Vantage", "v12-vantage"],
        ["V8", "v8"],
        ["V8 Vantage", "v8-vantage"],
        ["V8 Zagato", "v8-zagato"],
        ["Vanquish", "vanquish"],
        ["Vantage", "vantage"],
        ["Virage", "virage"],
        ["Volatne", "volatne"],
        ["DB11", "db11"],
        ["DBX", "dbx"],
        ["DBS Superleggera", "dbs-superleggera"],
        ["DBX707", "dbx707"],
    ],
    "bentley": [
        ["Arnage", "arnage"],
        ["Azure", "azure"],
        ["Brooklands", "brooklands"],
        ["Continental Flying Spur", "continental-flying-spur"],
        ["Continental GT", "continental-gt"],
        ["Eight", "eight"],
        ["Mulsanne", "mulsanne"],
        ["Turbo R", "turbo-r"],
        ["Turbo RT", "turbo-rt"],
        ["Turbo S", "turbo-s"],
        ["Bentayga", "bentayga"],
    ],
    "alpina": [
        ["B10", "b10"],
        ["B12", "b12"],
        ["B3", "b3"],
        ["B4", "b4"],
        ["B5", "b5"],
        ["B6", "b6"],
        ["B7", "b7"],
        ["B8", "b8"],
        ["D10", "d10"],
        ["D3", "d3"],
        ["D4", "d4"],
        ["D5", "d5"],
        ["Roadster S", "roadster-s"],
        ["XD3", "xd3"],
        ["XD4", "xd4"],
        ["XB7", "xb7"],
    ],
    "buick": [
        ["Centurion", "centurion"],
        ["Century", "century"],
        ["Electra", "electra"],
        ["Enclave", "enclave"],
        ["Lacrosse", "lacrosse"],
        ["Le Sabre", "le-sabre"],
        ["Lucerne", "lucerne"],
        ["Park Avenue", "park-avenue"],
        ["Reatta", "reatta"],
        ["Regal", "regal"],
        ["Rendezvous", "rendezvous"],
        ["Riviera", "riviera"],
        ["Roadmaster", "roadmaster"],
        ["Skyhawk", "skyhawk"],
        ["Skylark", "skylark"],
        ["Encore", "encore"],
    ],
    "cadillac": [
        ["Allante", "allante"],
        ["BLS", "bls"],
        ["Brougham", "brougham"],
        ["CTS", "cts"],
        ["Cimarron", "cimarron"],
        ["DTS", "dts"],
        ["Deville", "deville"],
        ["Eldorado", "eldorado"],
        ["Escalade", "escalade"],
        ["Fleetwood", "fleetwood"],
        ["SRX", "srx"],
        ["STS", "sts"],
        ["STS-V", "sts-v"],
        ["Seville", "seville"],
        ["XLR", "xlr"],
        ["XLR-V", "xlr-v"],
        ["ATS", "ats"],
        ["CT6", "ct6"],
        ["ELR", "elr"],
        ["SLS", "sls"],
        ["XT5", "xt5"],
        ["XTS", "xts"],
        ["Catera", "catera"],
        ["XT4", "xt4"],
        ["XT6", "xt6"],
    ],
    "chevrolet": [
        ["1500", "1500"],
        ["2500", "2500"],
        ["3500", "3500"],
        ["Alero", "alero"],
        ["Apache", "apache"],
        ["Astro", "astro"],
        ["Avalanche", "avalanche"],
        ["Aveo", "aveo"],
        ["Bel Air", "bel-air"],
        ["Beretta", "beretta"],
        ["Blazer", "blazer"],
        ["C-10", "c-10"],
        ["C-20", "c-20"],
        ["C-30", "c-30"],
        ["Camaro", "camaro"],
        ["Caprice", "caprice"],
        ["Captiva", "captiva"],
        ["Cavalier", "cavalier"],
        ["Celebrity", "celebrity"],
        ["Chevelle", "chevelle"],
        ["Chevy Van", "chevy-van"],
        ["Citation", "citation"],
        ["Cobalt", "cobalt"],
        ["Colorado", "colorado"],
        ["Corsica", "corsica"],
        ["Corvette", "corvette"],
        ["Cruze", "cruze"],
        ["El Camino", "el-camino"],
        ["Epica", "epica"],
        ["Equinox", "equinox"],
        ["Evanda", "evanda"],
        ["Express", "express"],
        ["G", "g"],
        ["HHR", "hhr"],
        ["Impala", "impala"],
        ["K1500", "k1500"],
        ["K30", "k30"],
        ["Kalos", "kalos"],
        ["Lacetti", "lacetti"],
        ["Lumina", "lumina"],
        ["Malibu", "malibu"],
        ["Matiz", "matiz"],
        ["Monte Carlo", "monte-carlo"],
        ["Monza", "monza"],
        ["Nova", "nova"],
        ["Nubira", "nubira"],
        ["Orlando", "orlando"],
        ["Rezzo", "rezzo"],
        ["S-10", "s-10"],
        ["SSR", "ssr"],
        ["Silverado", "silverado"],
        ["Spark", "spark"],
        ["Spectrum", "spectrum"],
        ["Suburban", "suburban"],
        ["Tacuma", "tacuma"],
        ["Tahoe", "tahoe"],
        ["Trailblazer", "trailblazer"],
        ["Trans Sport", "trans-sport"],
        ["Traverse", "traverse"],
        ["Trax", "trax"],
        ["Venture", "venture"],
        ["Volt", "volt"],
        ["Bolt", "bolt"],
    ],
    "chrysler": [
        ["300C", "300c"],
        ["300M", "300m"],
        ["Aspen", "aspen"],
        ["Caravan", "caravan"],
        ["Concorde", "concorde"],
        ["Crossfire", "crossfire"],
        ["Daytona", "daytona"],
        ["ES", "es"],
        ["GS", "gs"],
        ["GTS", "gts"],
        ["Grand Voyager", "grand-voyager"],
        ["LHS", "lhs"],
        ["Le Baron", "le-baron"],
        ["Neon", "neon"],
        ["New Yorker", "new-yorker"],
        ["PT Cruiser", "pt-cruiser"],
        ["Pacifica", "pacifica"],
        ["Prowler", "prowler"],
        ["Saratoga", "saratoga"],
        ["Sebring", "sebring"],
        ["Stratus", "stratus"],
        ["Town & Country", "town-country"],
        ["Valiant", "valiant"],
        ["Viper", "viper"],
        ["Vision", "vision"],
        ["Voyager", "voyager"],
        ["200", "200"],
        ["300", "300"],
        ["300s", "300s"],
    ],
    "daewoo": [
        ["Chairman", "chairman"],
        ["Cielo", "cielo"],
        ["Espero", "espero"],
        ["Evanda", "evanda"],
        ["Kalos", "kalos"],
        ["Korando", "korando"],
        ["Lacetti", "lacetti"],
        ["Lanos", "lanos"],
        ["Leganza", "leganza"],
        ["Matiz", "matiz"],
        ["Musso", "musso"],
        ["Nexia", "nexia"],
        ["Nubira", "nubira"],
        ["Racer", "racer"],
        ["Rezzo", "rezzo"],
        ["Tacuma", "tacuma"],
        ["Tico", "tico"],
    ],
    "dodge": [
        ["Avenger", "avenger"],
        ["Caliber", "caliber"],
        ["Caravan", "caravan"],
        ["Challenger", "challenger"],
        ["Charger", "charger"],
        ["Dakota", "dakota"],
        ["Dart", "dart"],
        ["Daytona", "daytona"],
        ["Diplomat", "diplomat"],
        ["Durango", "durango"],
        ["Dynasty", "dynasty"],
        ["Grand Caravan", "grand-caravan"],
        ["Hornet", "hornet"],
        ["Intrepid", "intrepid"],
        ["Journey", "journey"],
        ["Magnum", "magnum"],
        ["Monaco", "monaco"],
        ["Neon", "neon"],
        ["Nitro", "nitro"],
        ["Omni", "omni"],
        ["RAM", "ram"],
        ["Spirit", "spirit"],
        ["Stealth", "stealth"],
        ["Stratus", "stratus"],
        ["Viper", "viper"],
    ],
    "ds-automobiles": [
        ["DS 3", "ds-3"],
        ["DS 4", "ds-4"],
        ["DS 4 Crossback", "ds-4-crossback"],
        ["DS 5", "ds-5"],
        ["DS 7 Crossback", "ds-7-crossback"],
        ["DS 3 Crossback", "ds-3-crossback"],
        ["DS 9", "ds-9"],
    ],
    "ferrari": [
        ["208", "208"],
        ["248", "248"],
        ["250", "250"],
        ["288", "288"],
        ["308", "308"],
        ["328", "328"],
        ["330", "330"],
        ["348", "348"],
        ["360", "360"],
        ["365", "365"],
        ["400", "400"],
        ["412", "412"],
        ["456", "456"],
        ["458 Italia", "458-italia"],
        ["512", "512"],
        ["575", "575"],
        ["599GTB", "599gtb"],
        ["612", "612"],
        ["750", "750"],
        ["California", "california"],
        ["Daytona", "daytona"],
        ["Dino GT4", "dino-gt4"],
        ["Enzo", "enzo"],
        ["F12berlinetta", "f12berlinetta"],
        ["F355", "f355"],
        ["F360", "f360"],
        ["F40", "f40"],
        ["F430", "f430"],
        ["F50", "f50"],
        ["F550", "f550"],
        ["FF", "ff"],
        ["LaFerrari", "laferrari"],
        ["Mondial", "mondial"],
        ["Superamerica", "superamerica"],
        ["Testarossa", "testarossa"],
        ["488", "488"],
        ["GTC4Lusso", "gtc4lusso"],
        ["812 Superfast", "812-superfast"],
        ["Portofino", "portofino"],
        ["F8 Tributo", "f8-tributo"],
        ["F8 Spider", "f8-spider"],
        ["Roma", "roma"],
        ["812 GTS", "812-gts"],
        ["SF90 Stradale", "sf90-stradale"],
        ["SF90 Spider", "sf90-spider"],
        ["488 Pista", "488-pista"],
        ["488 Pista Spider", "488-pista-spider"],
        ["Portofino M", "portofino-m"],
    ],
    "hummer": [
        ["H1", "h1"],
        ["H2", "h2"],
        ["H3", "h3"],
    ],
    "infiniti": [
        ["EX", "ex"],
        ["FX", "fx"],
        ["G", "g"],
        ["I30", "i30"],
        ["I35", "i35"],
        ["J30", "j30"],
        ["M", "m"],
        ["Q45", "q45"],
        ["Q50", "q50"],
        ["Q60", "q60"],
        ["Q70", "q70"],
        ["QX", "qx"],
        ["QX50", "qx50"],
        ["QX70", "qx70"],
        ["Q30", "q30"],
        ["QX30", "qx30"],
        ["QX60", "qx60"],
        ["QX80", "qx80"],
    ],
    "lancia": [
        ["Beta", "beta"],
        ["Dedra", "dedra"],
        ["Delta", "delta"],
        ["Flamina", "flamina"],
        ["Fulvia", "fulvia"],
        ["Gamma", "gamma"],
        ["Kappa", "kappa"],
        ["Lybra", "lybra"],
        ["Musa", "musa"],
        ["Phedra", "phedra"],
        ["Prisma", "prisma"],
        ["Stratos", "stratos"],
        ["Thema", "thema"],
        ["Thesis", "thesis"],
        ["Voyager", "voyager"],
        ["Ypsilon", "ypsilon"],
        ["Zeta", "zeta"],
    ],
    "maybach": [
        ["57", "57"],
        ["62", "62"],
    ],
    "mclaren": [
        ["altul", "altul"],
        ["720S Spider", "720s-spider"],
        ["720S Coupe", "720s-coupe"],
        ["600LT Spider", "600lt-spider"],
        ["570 GT", "570-gt"],
        ["570S Coupe", "570s-coupe"],
        ["650S", "650s"],
        ["675Lt", "675lt"],
        ["GT", "gt"],
        ["Artura", "artura"],
        ["765LT Spider", "765lt-spider"],
        ["600LT Coupe", "600lt-coupe"],
        ["MP4-12C", "mp4-12c"]
    ],
    "mitsubishi": [
        ["3000GT", "3000gt"],
        ["ASX", "asx"],
        ["Canter", "canter"],
        ["Carisma", "carisma"],
        ["Colt", "colt"],
        ["Cordia", "cordia"],
        ["Cosmos", "cosmos"],
        ["Diamante", "diamante"],
        ["Eclipse", "eclipse"],
        ["Endeavor", "endeavor"],
        ["FTO", "fto"],
        ["Galant", "galant"],
        ["Galloper", "galloper"],
        ["Grandis", "grandis"],
        ["L200", "l200"],
        ["L300", "l300"],
        ["L400", "l400"],
        ["Lancer", "lancer"],
        ["Lancer Evolution", "lancer-evolution"],
        ["Montero", "montero"],
        ["Outlander", "outlander"],
        ["Pajero", "pajero"],
        ["Pajero Pinin", "pajero-pinin"],
        ["Santamo", "santamo"],
        ["Sapporo", "sapporo"],
        ["Sigma", "sigma"],
        ["Space Gear", "space-gear"],
        ["Space Runner", "space-runner"],
        ["Space Star", "space-star"],
        ["Space Wagon", "space-wagon"],
        ["Starion", "starion"],
        ["Tredia", "tredia"],
        ["i-MiEV", "i-miev"],
        ["Eclipse Cross", "eclipse-cross"]
    ],
    "ram": [
        ["1500", "1500"],
        ["2500", "2500"],
        ["3500", "3500"],
    ],
    "rolls-royce": [
        ["Corniche", "corniche"],
        ["Flying Spur", "flying-spur"],
        ["Ghost", "ghost"],
        ["Park Ward", "park-ward"],
        ["Phantom", "phantom"],
        ["Silver Cloud", "silver-cloud"],
        ["Silver Down", "silver-down"],
        ["Silver Seraph", "silver-seraph"],
        ["Silver Shadow", "silver-shadow"],
        ["Silver Spirit", "silver-spirit"],
        ["Silver Spur", "silver-spur"],
        ["Touring Limousine", "touring-limousine"],
        ["Wraith", "wraith"],
        ["Cullinan", "cullinan"],
        ["Dawn", "dawn"]
    ],
    "saab": [
        ["9-2X", "9-2x"],
        ["9-3", "9-3"],
        ["9-5", "9-5"],
        ["9-7X", "9-7x"],
        ["90", "90"],
        ["900", "900"],
        ["9000", "9000"],
        ["96", "96"],
        ["99", "99"],
        ["9-3X", "9-3x"]
    ],
    "ssangyong": [
        ["Actyon", "actyon"],
        ["Family", "family"],
        ["Korando", "korando"],
        ["Kyron", "kyron"],
        ["Musso", "musso"],
        ["REXTON", "rexton"],
        ["Rodius", "rodius"],
        ["Tivoli", "tivoli"],
        ["XLV", "xlv"],
        ["Tivoli Grand", "tivoli-grand"],
        ["Torres", "torres"]
    ],
    "subaru": [
        ["1800 Coupe", "1800-coupe"],
        ["B9 Tribeca", "b9-tribeca"],
        ["BRZ", "brz"],
        ["Baja", "baja"],
        ["Forester", "forester"],
        ["G3X Justy", "g3x-justy"],
        ["Impreza", "impreza"],
        ["Justy", "justy"],
        ["Legacy", "legacy"],
        ["Leone", "leone"],
        ["Outback", "outback"],
        ["SVX", "svx"],
        ["Trezia", "trezia"],
        ["Tribeca", "tribeca"],
        ["Vivio", "vivio"],
        ["XT", "xt"],
        ["XV", "xv"],
        ["Levorg", "levorg"],
        ["WRX", "wrx"],
        ["Ascent", "ascent"],
        ["Solterra", "solterra"]
    ],
    "tesla": [
        ["Model S", "model-s"],
        ["Roadster", "roadster"],
        ["Model X", "model-x"],
        ["Model 3", "model-3"],
        ["Y", "y"]
    ]
};
const findModel = (brand, model) => {
    var _a;
    if (brand && brand !== "") {
        return (_a = exports.MODELS_ARRAY[brand]) === null || _a === void 0 ? void 0 : _a.find(el => el[1] === model);
    }
};
exports.findModel = findModel;
const findModelByName = (brand, model) => {
    var _a;
    const brandObj = (0, Brand_1.findBrandByName)(brand);
    if (brandObj) {
        return (_a = exports.MODELS_ARRAY[brandObj[1]]) === null || _a === void 0 ? void 0 : _a.find(el => el[0] === model);
    }
};
exports.findModelByName = findModelByName;
const translateModel = (model) => {
    let finalModel;
    for (const [key, value] of Object.entries(exports.MODELS_ARRAY)) {
        const tmp = value.find(el => el[1] === model);
        if (tmp) {
            finalModel = tmp;
        }
    }
    if (finalModel) {
        return finalModel[0];
    }
    return model;
};
exports.translateModel = translateModel;
const translateModelToSlug = (model) => {
    let finalModel;
    for (const [key, value] of Object.entries(exports.MODELS_ARRAY)) {
        const tmp = value.find(el => el[0].toLowerCase() === model.toLowerCase());
        if (tmp) {
            finalModel = tmp;
        }
    }
    if (finalModel) {
        return finalModel[1];
    }
    return model;
};
exports.translateModelToSlug = translateModelToSlug;
const getModelsWithBrand = () => {
    const finalModel = [];
    for (const [brandValue, modelsArray] of Object.entries(exports.MODELS_ARRAY)) {
        for (const [modelLabel, modelValue] of modelsArray) {
            const obj = {
                label: `${(0, Brand_1.translateBrand)(brandValue)} ${modelLabel}`,
                brand: brandValue,
                model: modelValue,
            };
            finalModel.push(obj);
        }
    }
    return finalModel;
};
exports.getModelsWithBrand = getModelsWithBrand;
//# sourceMappingURL=Model.js.map